import React, { useState, useEffect } from "react";
import useToCancelOrders from "../../hooks/useToCancelOrders";
const Stopwatch = ({ orderID, start, order }) => {
  const [time, setTime] = useState(null);
  const { getTheOrder } = useToCancelOrders();

  useEffect(() => {
    calculateTimebyUpdatedDate();
    //return () => {};
  }, []);

  useEffect(() => {
    if (time !== null && time > 0) {
      setTimeout(() => {
        setTime(time - 1);
      }, 1000);
    } else if (time === 0) {
      //console.log("Cancelar la orden");
      getTheOrder(order.id, order, orderID);
    }

    return () => {};
  }, [time]);

  function calculateTimebyUpdatedDate() {
    let _start = start.substring(0, 10) + " " + start.substring(11, 19);
    let deadline = new Date(_start);

    // This is where you need to adjust if
    // you entend to add more time
    deadline.setSeconds(deadline.getSeconds() + 30);
    const total = Date.parse(new Date(deadline)) - Date.parse(new Date());
    const seconds = Math.floor((total / 1000) % 60);
    const minutes = Math.floor((total / 1000 / 60) % 60);

    var allTime = minutes * 60 + seconds;
    if (allTime <= 0) {
      setTime(0);
      return 0;
    } else {
      setTime(allTime);
      return allTime;
    }
  }

  return (
    <div className="row">
      {time !== 0 && time !== null ? <p>Tiempo restante: {time} </p> : null}
    </div>
  );
};

export default Stopwatch;
